import React, { useEffect,useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import { Row, FormInstance,  Spin,Input, Image } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { useModalState } from 'hooks/useModalState';
import ParListSelect from 'components/ParListSelect';
import { toCurrency } from 'utils/utils';
import UtinaCard from 'components/UtinaCard';
import Text from 'antd/lib/typography/Text';
import TextArea from 'antd/lib/input/TextArea';
import { useQuery } from 'react-query';
import { getAssetsByID } from 'services/assets';
import { UPLOAD_IMG_URL } from 'utils/config';

export type TabCreateAssetCatalogFromAssetProps = {
  form?: FormInstance;
  objectid?: number;
  dataInput?: any;
  setSuccessful?:any;
};

const TabSaveAssetAsCatalog = ({
  objectid,
  form,
  dataInput,
  setSuccessful,
}: TabCreateAssetCatalogFromAssetProps) => {
  const { close: closemodal, open: openmodal, visible } = useModalState();
  const [searchParams] = useState<any>({
    objectid: objectid,
  });

  const { data: asset, isFetching } = useQuery(
    ['getAssetsByID', { assetid: objectid }],
    () =>
      getAssetsByID({ assetid: objectid??0 }).then((res) => {
        return res.data;
      }),
    { refetchOnMount: true }
  );

  useEffect(() => {
    setSuccessful(isFetching);
          form?.setFieldsValue({
            assetreference:asset?.assetreference,
            assetsegment:asset?.assetsegmentlabel,
            assetfamily:asset?.assetfamilylabel,
            assettype:asset?.assettypelabel,
            assetcategory:asset?.assetcategorylabel,
            assetmodel:asset?.assetmodel,
            assetlabel:asset?.assetlabel,
            assetdesccription:asset?.assetdescription??asset?.assetlabel,
            assetnetamount: asset?.assetnetamount,
            assettaxamount: asset?.assettaxamount,
            assetgrossamount: asset?.assetgrossamount,
            assetid: objectid,
            event: 'tabSaveAssetAsCatalog',

          });
  }, [isFetching]);

  return (
    <DF.Provider pagcode="tabsaveassetascatalog">
    <Spin spinning={isFetching}>
      
        <Row>
          <UtinaCard
            level={5}
            comcode="assetGeneralInformation"
            style={{ color: '#000' }}
            lg={11}
            additionalAttribute
          >
            <FormInput
              col
              lg={8}
              name="assetreference"
              comcode="assetreference"
            >
              <Text>{asset?.assetreference}</Text>
            </FormInput>
            <FormInput name="statuslabel" col xs={4}>
              <Text>{asset?.statuslabel}</Text>
            </FormInput>
            <FormInput
              col
              md={24}
              name="assetlabel"
              comcode="assetlabel"
              rules={[{ required: true }]}
            >
              <Input defaultValue={asset?.assetlabel}></Input>
            </FormInput>

            <FormInput name="assetsegmentlabel" col xs={4}>
            <Text>{asset?.assetsegmentlabel}</Text>
            </FormInput>
            <FormInput name="assetfamilylabel" col xs={4}>
            <Text>{asset?.assetfamilylabel}</Text>
            </FormInput>
            <FormInput name="assettypelabel" col xs={4}>
            <Text>{asset?.assettypelabel}</Text>
            </FormInput>
            <FormInput name="assetcategorylabel" col xs={4}>
            <Text>{asset?.assetcategorylabel}</Text>
            </FormInput>
            <FormInput name="assetmodellabel" col xs={4}>
            <Text>{asset?.assetmodel}</Text>
            </FormInput>
            <FormInput col xs={24} name="assetdescription">
              <TextArea rows={3} maxLength={500} defaultValue={asset?.assetdescription}></TextArea>
            </FormInput>
          </UtinaCard>
          <UtinaCard
            level={5}
            lg={5}
            comcode="assetPicture"
            additionalAttribute
          >
            <Image
              preview={{ visible: false }}
              src={UPLOAD_IMG_URL    +asset?.assetpictureurl}
              onClick={() => {}}
            />
          </UtinaCard>
          <UtinaCard
            level={5}
            comcode="assetFinancialInfo"
            style={{ color: '#000', padding: 15 }}
            lg={6}
          >
            <FormInput
              col
              xs={24}
              md={12}
              name="currcode"
              rules={[{ required: true }]}
            >
              <ParListSelect parcode="CURRENCY" />
            </FormInput>

                  <FormInput name="assetnetamount" col md={12}>
                    <Text strong>
                      {toCurrency(
                        form?.getFieldValue('assetnetamount'),
                        form?.getFieldValue('currcode')
                      )}
                    </Text>
                  </FormInput>
               
                  <FormInput col md={12} name="assettaxamount">
                    <Text strong>
                      {toCurrency(
                        form?.getFieldValue('assettaxamount'),
                        form?.getFieldValue('currcode')
                      )}
                    </Text>
                  </FormInput>
                  <FormInput col md={12} name="assetgrossamount">
                    <Text strong>
                      {toCurrency(
                        form?.getFieldValue('assetgrossamount'),
                        form?.getFieldValue('currcode')
                      )}
                    </Text>
                  </FormInput>
          </UtinaCard>
   
        </Row>

      </Spin>
    </DF.Provider>
  );
};
export default TabSaveAssetAsCatalog;
